<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col cols="12" class="pa-2 px-1">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">{{ title }}</p>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container class="pt-2" fluid>
                    <v-row class="ma-0 pb-3 pa-1 pa-sm-4">
                        <v-col class="px-1 px-sm-4 py-0" cols="12" :sm="multipleTo ? 12 : 9">
                            <v-combobox
                                dense
                                required
                                outlined
                                label="A"
                                small-chips
                                :multiple="multipleTo"
                                :deletable-chips="multipleTo"
                                :clearable="multipleTo"
                                :items="emailsTo"
                                :data-vv-name="'A'"
                                v-model="model['to']"
                                :return-object="false"
                                v-validate="'email|required'"
                                @input="toTouched = true"
                                :error-messages="errors.collect('A')">
                                <template v-slot:item="data">
                                    <v-list-item-avatar
                                        size="32px"
                                        style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                        class="primary mr-4">
                                        <v-icon class="fs18i" color="white">mail</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <span>{{ data.item.subtitle }}</span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-combobox>
                        </v-col>
                        <v-col v-if="!multipleTo" class="px-1 px-sm-4 py-0" cols="12" sm="3">
                            <v-switch v-model="model['update_email']" inset label="Aggiorna email aziendale" color="primary" class="margin-auto"></v-switch>
                        </v-col>
                        <v-col v-if="multipleTo" class="px-1 px-sm-4 py-0 pb-4" cols="12">
                            <div class="d-flex align-center flex-wrap">
                                <span class="text-caption mr-2 mb-1">Liste di distribuzione:</span>
                                <v-chip
                                    v-for="lista in distributionLists"
                                    :key="lista.id"
                                    small
                                    outlined
                                    color="primary"
                                    class="mr-1 mb-1"
                                    @click="applyDistributionList(lista)">
                                    <v-icon left x-small>mdi-account-multiple-outline</v-icon>
                                    {{ lista.name }}
                                </v-chip>
                                <v-chip
                                    small
                                    outlined
                                    class="mb-1"
                                    :disabled="!currentEmails.length"
                                    @click="openSaveListDialog">
                                    <v-icon left x-small>mdi-content-save-outline</v-icon>
                                    Salva destinatari come lista
                                </v-chip>
                                <v-tooltip top v-if="distributionLists.length">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon x-small class="ml-1 mb-1" @click="manageListsDialog = true">
                                            <v-icon small>mdi-cog-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Gestisci liste di distribuzione</span>
                                </v-tooltip>
                            </div>
                        </v-col>
                        <v-col class="px-1 px-sm-4 py-0" cols="12" lg="6">
                            <v-combobox
                                name="from"
                                label="Da"
                                small-chips
                                combobox
                                clearable
                                required
                                v-model="model['from']"
                                :error-messages="errors.collect('Da')"
                                v-validate="'email|required'"
                                :data-vv-name="'Da'"
                                outlined
                                dense
                            ></v-combobox>
                        </v-col>
                        <v-col class="px-1 px-sm-4 py-0" cols="12" lg="6">
                            <v-combobox
                                label="Nome Mittente"
                                small-chips
                                combobox                                
                                clearable
                                v-model="model['fromName']"
                                color="primary"
                                outlined
                                dense>
                                <v-slide-x-reverse-transition
                                    class="ma-0"
                                    slot="append-outer"
                                    mode="out-in">
                                    <div class="d-flex">
                                            <v-chip
                                                small
                                                :color="showCc ? 'primary' : ''"
                                                :outlined="!showCc"
                                                @click="closeCc"
                                                class="mr-1"
                                            >Cc</v-chip>
                                            <v-chip
                                                small
                                                :color="showCcn ? 'primary' : ''"
                                                :outlined="!showCcn"
                                                @click="closeCcn"
                                            >Ccn</v-chip>
                                        </div>
                                </v-slide-x-reverse-transition>
                            </v-combobox>
                        </v-col>
                        <transition name="fade">
                            <v-col class="px-1 px-sm-4 py-0 transition" cols="12" v-if="showCc">
                                <v-combobox
                                    name="cc"
                                    label="Cc"
                                    :items="ccItems"
                                    small-chips
                                    combobox
                                    dense
                                    clearable
                                    multiple
                                    :return-object="false"
                                    v-model="model['cc']"
                                    :error-messages="errors.collect('Cc')"
                                    v-validate="'email'"
                                    :data-vv-name="'Cc'"
                                    outlined
                                >
                                    <template v-slot:item="data">
                                        <v-list-item-avatar
                                            size="32px"
                                            style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                            class="primary mr-4">
                                            <v-icon class="fs18i" color="white">mail</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="data.item.subtitle">
                                                <span>{{ data.item.subtitle }}</span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-combobox>
                            </v-col>
                        </transition>
                        <transition name="fade">
                            <v-col class="px-1 px-sm-4 py-0 transition" cols="12" v-if="showCcn">
                                <v-combobox
                                    name="ccn"
                                    label="Ccn"
                                    :items="ccnItems"
                                    small-chips
                                    combobox
                                    dense
                                    clearable
                                    multiple
                                    :return-object="false"
                                    v-model="model['ccn']"
                                    :error-messages="errors.collect('Ccn')"
                                    v-validate="'email'"
                                    :data-vv-name="'Ccn'"
                                    outlined
                                >
                                    <template v-slot:item="data">
                                        <v-list-item-avatar
                                            size="32px"
                                            style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                            class="primary mr-4">
                                            <v-icon class="fs18i" color="white">mail</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="data.item.subtitle">
                                                <span>{{ data.item.subtitle }}</span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-combobox>
                            </v-col>
                        </transition>

                        <v-col class="px-1 px-sm-4 py-0" cols="12" sm="6">
                            <v-text-field
                                name="subject"
                                label="Oggetto"
                                v-model="model['subject']"
                                :error-messages="errors.collect('Oggetto')"
                                required
                                v-validate="'required'"
                                :data-vv-name="'Oggetto'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="px-1 px-sm-4 py-0" cols="6">
                            <v-select
                                :items="model['template_mail']"
                                label="Template Mail"
                                hint="Seleziona il template da inserite nella mail"
                                :required="false"
                                v-model="model['default_template']"
                                :menu-props="{'offset-y': true}"
                                return-object
                                dense
                                @change="setTemplateInTextEditor($event, true)"
                                outlined>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-avatar
                                            size="32px"
                                            style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                            class="primary mr-4">
                                            <v-icon class="fs18i" color="white">mail</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <span v-for="(key, k) in ['subtitle']" :key="k">{{$trans(data.item[key])}}&nbsp;
                                                </span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-select>
                        </v-col>                            
                        <v-col class="px-1 px-sm-4 py-0" cols="6" >
                            <v-select
                                :items="signatures" 
                                label="Firma"
                                hint="Seleziona una firma da inserite nella mail"
                                :required="false"
                                v-model="signatureSelected"
                                :menu-props="{'offset-y': true}"
                                return-object
                                dense
                                outlined>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-avatar
                                            size="32px"
                                            style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                            class="primary mr-4">
                                            <v-icon class="fs18i" color="white">draw</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <span v-for="(key, k) in ['subtitle']" :key="k">{{$trans(data.item[key])}}&nbsp;
                                                </span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col class="px-1 px-sm-4 py-0" cols="6" v-if="attachmentIncluded">
                            <v-switch
                                v-model="model['attachmentIncluded']"
                                inset
                                label="Includi allegato documento"
                                color="primary"
                                class="margin-auto">
                            </v-switch>
                        </v-col>

                        <v-col class="px-1 px-sm-4 py-0 d-block" cols="12">
                            <tinymce-editor
                                v-if="$store.getters.checkSettings('use_tinymce_editor')"
                                editor-id="mail-text"
                                v-model="model['body']"
                                ref="tinymceEditor"
                            />
                            <vue-editor v-else
                                id="mail-text"
                                v-model="model['body']"
                            ></vue-editor>
                        </v-col>
                        <v-col class="col-12 py-0">
                            <v-subheader class="pl-0 text-subtitle-1 font-weight-medium">
                                <v-icon left small>mdi-paperclip</v-icon>
                                Seleziona file esistenti da allegare
                            </v-subheader>
                        </v-col>
                        <v-col cols="12" class="py-2" v-for="(category, name, i) in availableAttachments" :key="i">
                            <v-card outlined class="pa-3">
                                <!-- Category Header -->
                                <div class="d-flex align-center justify-space-between" :class="{ 'mb-3': category.length > 0 }">
                                    <div class="d-flex align-center">
                                        <v-icon small class="mr-2" color="primary">mdi-folder-outline</v-icon>
                                        <span class="text-subtitle-2 font-weight-medium">{{ $trans(name) }}</span>
                                        <v-chip x-small class="ml-2">{{ category.length }}</v-chip>
                                    </div>
                                    <v-btn
                                        v-if="category.length > 0"
                                        x-small
                                        text
                                        color="primary"
                                        @click="selectAll(name)"
                                    >
                                        <v-icon x-small left>{{ allAttachment[name] ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                                        {{ allAttachment[name] ? 'Deseleziona tutti' : 'Seleziona tutti' }}
                                    </v-btn>
                                </div>
                                <!-- Empty state message -->
                                <div v-if="category.length === 0" class="text-center py-2">
                                    <span class="text-caption">Nessun file disponibile</span>
                                </div>
                                <!-- Files Grid -->
                                <v-row v-else>
                                    <v-col
                                        cols="12" sm="6" md="4"
                                        v-for="(file, c) in category"
                                        :key="c+'j'"
                                        class="py-1"
                                    >
                                        <v-card
                                            flat
                                            :class="[
                                                'file-card pa-2 cursor-pointer',
                                                filesSelected[name] && filesSelected[name].includes(file.id) ? 'file-card--selected' : ''
                                            ]"
                                            @click="toggleFileSelection(name, file.id)"
                                        >
                                            <div class="d-flex align-center">
                                                <v-checkbox
                                                    color="primary"
                                                    :value="file.id"
                                                    v-model="filesSelected[name]"
                                                    hide-details
                                                    class="ma-0 pa-0 mr-2 flex-shrink-0"
                                                    @click.stop
                                                ></v-checkbox>
                                                <v-icon small class="mr-2 flex-shrink-0" :color="getFileIconColor(file.ext || file.name)">
                                                    {{ getFileIcon(file.ext || file.name) }}
                                                </v-icon>
                                                <div class="file-info">
                                                    <div class="text-body-2 file-name" :title="$options.filters.fileName(file.name, file.ext)">{{ file.name | fileName(file.ext) }}</div>
                                                    <div class="text-caption">
                                                        {{ file.size | byte }}
                                                        <span v-if="file.created_at"> · {{ file.created_at | date }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>

                        <v-col class="pt-3 px-1 px-sm-4" cols="12">
                            <file-uploader class="pt-3 pa-0" v-if="fileUploaderInfo.attachableType"
                                :id="id"
                                :attachable-type="fileUploaderInfo.attachableType"
                                :options="fileUploaderInfo.options ? fileUploaderInfo.options : {}"
                                :field="fileUploaderInfo"
                                :start-empty="true"
                            ></file-uploader>
                        </v-col>

                    </v-row>
                    <small class="px-1 px-sm-4">* Indica i campi obbligatori</small>
                </v-container>
            </v-card>
        </v-col>
        <v-tooltip top>
			<template v-slot:activator="{ on: tooltip }">
				<v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="validateFields()"
                        :loading="sent"
                        color="info"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon size="32">mdi-email-fast-outline</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Invia</span>
        </v-tooltip>        
        <v-dialog v-model="saveListDialog" max-width="480" class="round-card">
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Salva lista di distribuzione</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                    <v-combobox
                        label="Nome lista"
                        :items="distributionLists.map(lista => lista.name)"
                        v-model="saveListName"
                        hint="Scegli un nome esistente per aggiornare quella lista con i destinatari attuali"
                        persistent-hint
                        dense
                        outlined
                    ></v-combobox>
                    <div class="text-caption mt-4">Destinatari: {{ currentEmails.join(', ') }}</div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn text @click="saveListDialog = false">Annulla</v-btn>
                    <v-btn color="primary" text :loading="savingList" :disabled="!saveListName || !String(saveListName).trim()" @click="saveDistributionList">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="manageListsDialog" max-width="520" class="round-card" scrollable>
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Gestisci liste di distribuzione</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-3">
                    <v-list dense class="background-2">
                        <template v-for="(lista, index) in distributionLists">
                            <v-list-item :key="lista.id" v-if="editingListId !== lista.id">
                                <v-list-item-content>
                                    <v-list-item-title>{{ lista.name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ lista.emails.join(', ') }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action class="flex-row">
                                    <v-btn icon @click="startListEdit(lista)">
                                        <v-icon>mdi-pencil-outline</v-icon>
                                    </v-btn>
                                    <v-btn icon color="error" @click="listToDelete = lista">
                                        <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item :key="lista.id" v-else>
                                <v-list-item-content>
                                    <v-text-field
                                        label="Nome lista"
                                        v-model="editListName"
                                        dense
                                        outlined
                                        hide-details
                                        class="mb-2"
                                    ></v-text-field>
                                    <v-combobox
                                        label="Email"
                                        :items="emailsTo"
                                        v-model="editListEmails"
                                        :return-object="false"
                                        multiple
                                        small-chips
                                        deletable-chips
                                        dense
                                        outlined
                                        hide-details
                                    ></v-combobox>
                                </v-list-item-content>
                                <v-list-item-action class="flex-row align-start">
                                    <v-btn icon color="primary" :loading="savingListEdit" :disabled="!editListName.trim() || !editListEmails.length" @click="saveListEdit(lista)">
                                        <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="editingListId = null">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider v-if="index < distributionLists.length - 1" :key="'div-' + lista.id"></v-divider>
                        </template>
                    </v-list>
                    <div v-if="!distributionLists.length" class="text-caption text-center py-4">Nessuna lista di distribuzione per questo fornitore</div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="manageListsDialog = false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <confirm-dialog
            :confirmModel="!!listToDelete"
            mainTitle="Eliminare la lista di distribuzione?"
            :secondTitle="listToDelete ? 'La lista \'' + listToDelete.name + '\' non sarà più proposta all\'invio degli ordini di acquisto di questo fornitore' : ''"
            @update:confirmModel="listToDelete = null"
            :atConfirm="deleteDistributionList"
            :confirm="{color: 'error', label: 'elimina'}"
        ></confirm-dialog>
        <confirm-dialog
            :confirmModel="confirmSendMail"
            mainTitle="Sei sicuro di inviare la mail con queste informazioni?"
            secondTitle="Una volta premuto 'Invia' la mail verrà aggiunta a una coda di invio, potrai seguire lo stato della mail dai Mail Log e all'apertura del messaggio da parte del cliente riceverai una notifica"
            @update:confirmModel="confirmSendMail = false"
            :atConfirm="beforeSend"
            :confirm="{color: 'info', label: 'invia'}"
        ></confirm-dialog>
    </v-row>
</template>

<script>
	import MailTemplateMixin from '@/mixins/MailTemplateMixin'
	import FileUploader from '@/components/common/FileUploader.vue'

    export default {
        name: 'send-mail',
		mixins: [MailTemplateMixin],
        components: {
            FileUploader
        },
        props: {
            id: Number,
            title: String,
            route: String,
            redirect: {
                type: Object,
                default: () => {}
            },
            companyModel: {
                type: String,
                default: 'companies'
            },
            model_name: String,
            attachmentIncluded: {
                type: Boolean,
                default: true
            },
            multipleTo: {
                type: Boolean,
                default: false
            },
            sendType: {
                type: String,
                default: 'intervention'
            }
        },
        data() {
            return {
                cc: {},
                ccn: {},
                form: null,
                sent:false,
                baseurl: '',
                emailsTo: [],
                company_id: null,
                showCc: false,
                showCcn: false,
                signatures: [],
                fileUploaderInfo: {},
                signatureSelected: '',
                confirmSendMail: false,
                distributionLists: [],
                manageListsDialog: false,
                saveListDialog: false,
                saveListName: '',
                savingList: false,
                listToDelete: null,
                editingListId: null,
                editListName: '',
                editListEmails: [],
                savingListEdit: false,
                toTouched: false,
                availableAttachments: [],
                filesSelected: {},
                allAttachment: {},
                files: [],
                model: {
                    attachmentIncluded: this.attachmentIncluded,
                    files: [],
                    id: this.id,
                    body: ''
                },
            }
        },

        computed: {

            // Destinatari correnti del campo "A" normalizzati ad array
            currentEmails() {
                if (this.multipleTo) {
                    return this.model['to'] || []
                }
                return this.model['to'] ? [this.model['to']] : []
            },

            ccItems() {
                return this.recipientItems(this.cc)
            },

            ccnItems() {
                return this.recipientItems(this.ccn)
            }
        },

        watch: {

            filesSelected: {
                handler(newVal, oldVal) {
                    _.forEach((newVal), (value, name) => {
                        if(value.length == this.availableAttachments[name].length) {
                            this.allAttachment[name] = true
                        } else {
                            this.allAttachment[name] = false
                        }
                    })
                },
                deep:true
            },
            
            // Add a specific watcher for signatureSelected in this component
            signatureSelected: {
                handler(newVal, oldVal) {
                    // Only run this if we're not in initialization mode
                    if (this.isInitializing) return
                    
                    // If no template was selected (empty template_mail array case)
                    if (!this.model['default_template'] || !this.model['default_template'].body) {
                        // Get signature content
                        const signatureContent = newVal && newVal.body ? newVal.body : ''
                        
                        // Get current body content (could be empty)
                        let currentBody = this.model.body || ''
                        
                        // Remove old signature if exists
                        if (oldVal && oldVal.body) {
                            // Check for different signature separator patterns
                            const separatorPatterns = [
                                '<p><br></p><p>--</p>' + oldVal.body,
                                '<p>--</p>' + oldVal.body,
                                '<p><br></p>' + oldVal.body,
                                oldVal.body
                            ]
                            
                            // Try to remove the old signature with its separator
                            for (const pattern of separatorPatterns) {
                                if (currentBody.endsWith(pattern)) {
                                    currentBody = currentBody.substring(0, currentBody.length - pattern.length)
                                    break
                                }
                            }
                        }
                        
                        // Add new signature if available
                        if (signatureContent) {
                            // Check if signature already has a separator
                            const startsWithSeparator = signatureContent.startsWith('<p>--</p>')
                            
                            // Use appropriate separator based on signature format
                            const separator = startsWithSeparator ? '<p><br></p>' : '<p><br></p><p>--</p>'
                            
                            // Only add separator if there's content already
                            if (currentBody.trim()) {
                                currentBody += separator
                            }
                            
                            currentBody += signatureContent
                        }
                        
                        // Update model body
                        this.model.body = currentBody
                    }
                },
                deep: true
            }
        },

        methods: {

            // Voci per Cc/Ccn: prima gli indirizzi dell'anagrafica (gli stessi del campo
            // "A", con il nominativo come sottotitolo), poi le email degli utenti restituite
            // dalla info. I duplicati vengono scartati mantenendo la prima occorrenza.
            recipientItems(users) {
                let items = []
                let seen = {}

                let push = (value, subtitle) => {
                    if (!value || seen[value]) return
                    seen[value] = true
                    items.push({ text: value, value: value, subtitle: subtitle || '' })
                }

                _.forEach(this.emailsTo, item => push(item.value, item.subtitle))
                _.forEach(users, user => push(typeof user === 'string' ? user : (user ? user.value : null), 'Utente'))

                return items
            },

            closeCc() {
                this.showCc = !this.showCc
                this.model['cc'] ? this.model['cc'].splice(0) : null
            },

            // Applica la lista al campo "A": se contiene solo il prefill automatico
            // mai toccato dall'utente lo sostituisce, altrimenti aggiunge senza duplicati
            applyDistributionList(lista) {
                if (!this.toTouched) {
                    this.$set(this.model, 'to', lista.emails.slice())
                    this.toTouched = true
                } else {
                    let emails = (this.model['to'] || []).slice()
                    let existing = emails.map(email => String(email).toLowerCase())
                    lista.emails.forEach(email => {
                        if (!existing.includes(String(email).toLowerCase())) {
                            emails.push(email)
                            existing.push(String(email).toLowerCase())
                        }
                    })
                    this.$set(this.model, 'to', emails)
                }
                this.$nextTick(() => this.$validator.validate('A'))
            },

            startListEdit(lista) {
                this.editingListId = lista.id
                this.editListName = lista.name
                this.editListEmails = lista.emails.slice()
            },

            saveListEdit(lista) {
                const name = this.editListName.trim()
                if (!name || !this.editListEmails.length) {
                    return
                }

                this.savingListEdit = true
                this.axios.put('distributionlists/' + lista.id, { name: name, emails: this.editListEmails }).then(response => {
                    const index = this.distributionLists.indexOf(lista)
                    if (index > -1) {
                        this.distributionLists.splice(index, 1, response.data.list)
                    }
                    this.savingListEdit = false
                    this.editingListId = null
                }, () => {
                    this.savingListEdit = false
                })
            },

            openSaveListDialog() {
                this.saveListName = ''
                this.saveListDialog = true
            },

            // Crea la lista o, se il nome coincide con una esistente, la aggiorna
            saveDistributionList() {
                const name = String(this.saveListName || '').trim()
                if (!name || !this.currentEmails.length) {
                    return
                }

                this.savingList = true
                const existing = this.distributionLists.find(lista => lista.name.toLowerCase() === name.toLowerCase())
                const payload = { name: name, emails: this.currentEmails }

                const request = existing
                    ? this.axios.put('distributionlists/' + existing.id, payload)
                    : this.axios.post('distributionlists', { ...payload, company_id: this.company_id })

                request.then(response => {
                    if (existing) {
                        const index = this.distributionLists.indexOf(existing)
                        this.distributionLists.splice(index, 1, response.data.list)
                    } else {
                        this.distributionLists.push(response.data.list)
                    }
                    this.savingList = false
                    this.saveListDialog = false
                }, () => {
                    this.savingList = false
                })
            },

            deleteDistributionList() {
                const lista = this.listToDelete
                if (!lista) {
                    return
                }
                this.axios.post('distributionlists/delete', { ids: [lista.id] }).then(() => {
                    const index = this.distributionLists.indexOf(lista)
                    if (index > -1) {
                        this.distributionLists.splice(index, 1)
                    }
                    this.listToDelete = null
                }, () => {
                    this.listToDelete = null
                })
            },

            closeCcn() {
                this.showCcn = !this.showCcn
                this.model['ccn'] ? this.model['ccn'].splice(0) : null
            },

            beforeSend() {
                this.sent = true
                if(this.model.update_email && !this.multipleTo) {
                    this.axios.put(this.companyModel + '/' + this.company_id, {'primary_email': this.model.to}).then(response => {
                        this.sendMail()
                    }, response => {
                        // error callback
                    })
                } else {
                    this.sendMail()
                }
            },

            sendMail() {
                _.forEach(this.filesSelected, (category) => {
                    _.forEach(category, (id) => {
                        this.model.files.push(id)
                    })
                })
                
                _.forEach(this.files, (file) => {
                    this.model.files.push(file)
                })

                this.axios.post(this.route + '-send-mail', this.model).then(response => {
                    this.sent = false
                    if(!_.isEmpty(this.redirect)) {
                        this.$eventBusUtility.goTo(this.$router, this.redirect.modelDef + '-show', this.id, null, this.redirect.params)
                    } else {
                        this.$router.push({ name: this.route + '-show', params: { id: parseInt(this.id) }})
                    }

                }, response => {
                    // error callback
                    this.sent = false
                })
            },

            selectAll(name) {
                if (this.allAttachment[name]) {
                    // Deselect all
                    this.filesSelected[name] = []
                } else {
                    // Select all
                    this.filesSelected[name] = this.availableAttachments[name].map(file => file.id)
                }
            },

            toggleFileSelection(name, fileId) {
                if (!this.filesSelected[name]) {
                    this.$set(this.filesSelected, name, [])
                }
                const index = this.filesSelected[name].indexOf(fileId)
                if (index > -1) {
                    this.filesSelected[name].splice(index, 1)
                } else {
                    this.filesSelected[name].push(fileId)
                }
            },

            getFileIcon(filename) {
                const ext = filename.split('.').pop().toLowerCase()
                const icons = {
                    pdf: 'mdi-file-pdf-box',
                    doc: 'mdi-file-word',
                    docx: 'mdi-file-word',
                    xls: 'mdi-file-excel',
                    xlsx: 'mdi-file-excel',
                    ppt: 'mdi-file-powerpoint',
                    pptx: 'mdi-file-powerpoint',
                    jpg: 'mdi-file-image',
                    jpeg: 'mdi-file-image',
                    png: 'mdi-file-image',
                    gif: 'mdi-file-image',
                    zip: 'mdi-folder-zip',
                    rar: 'mdi-folder-zip',
                    txt: 'mdi-file-document-outline',
                    csv: 'mdi-file-delimited'
                }
                return icons[ext] || 'mdi-file-outline'
            },

            getFileIconColor(filename) {
                const ext = filename.split('.').pop().toLowerCase()
                const colors = {
                    pdf: 'red',
                    doc: 'blue',
                    docx: 'blue',
                    xls: 'green',
                    xlsx: 'green',
                    ppt: 'orange',
                    pptx: 'orange',
                    jpg: 'purple',
                    jpeg: 'purple',
                    png: 'purple',
                    gif: 'purple',
                    zip: 'amber',
                    rar: 'amber'
                }
                return colors[ext] || 'grey'
            },

            preselectMostRecentFile(categoryName) {
                // Trova il file più recente nella categoria specificata basandosi su created_at
                if (!this.availableAttachments) return
                const category = this.availableAttachments[categoryName]
                if (!category || category.length === 0) return

                let mostRecentFile = null

                _.forEach(category, (file) => {
                    if (file.created_at) {
                        if (!mostRecentFile || new Date(file.created_at) > new Date(mostRecentFile.created_at)) {
                            mostRecentFile = file
                        }
                    }
                })

                // Seleziona il file più recente se trovato
                if (mostRecentFile) {
                    if (!this.filesSelected[categoryName]) {
                        this.$set(this.filesSelected, categoryName, [])
                    }
                    this.filesSelected[categoryName].push(mostRecentFile.id)
                }
            }
        },

        mounted() {
            this.$eventBusUtility.$on('paths', (files) => {
                this.$set(this, 'files', files)
            })
        },

        beforeDestroy() {
			this.$eventBusUtility.$off('paths')
		},        

        created() {
            let data = {
                id: this.id,
                type: this.sendType
            }
            this.axios.post(this.route + '-send-mail-info', data).then(response => {
                // get body data
                this.model['from'] = response.data.info.from
                this.model['fromName'] = response.data.info.fromName
                if (this.multipleTo) {
                    // $set: 'to' non esiste nel model iniziale e senza reattività
                    // il computed currentEmails non si aggiornerebbe
                    this.$set(this.model, 'to', typeof response.data.info.to[0] === 'undefined' ? [] : [response.data.info.to[0].value])
                    this.distributionLists = response.data.info.distribution_lists || []
                } else {
                    this.model['to'] = typeof response.data.info.to[0] === 'undefined' ? '' : response.data.info.to[0].value
                }
                this.model['subject'] = response.data.info.subject
                this.model['template_mail'] = response.data.info.template_mail || []
                this.company_id = response.data.info.company_id
                this.signatures = response.data.info.signatures || []
                this.emailsTo = response.data.info.to
                this.cc = response.data.info.cc
                this.ccn = response.data.info.ccn

                // Precompila CC/CCN di default configurati nelle impostazioni del documento.
                // Restano modificabili dall'utente prima dell'invio.
                if (Array.isArray(response.data.info.cc_default) && response.data.info.cc_default.length) {
                    this.$set(this.model, 'cc', response.data.info.cc_default.slice())
                    this.showCc = true
                }
                if (Array.isArray(response.data.info.ccn_default) && response.data.info.ccn_default.length) {
                    this.$set(this.model, 'ccn', response.data.info.ccn_default.slice())
                    this.showCcn = true
                }

                this.availableAttachments = response.data.info.relation_files
                _.forEach(this.availableAttachments, (category, name) => {
                    this.$set(this.filesSelected, name, [])
                })

                // Imposta il default per attachmentIncluded dal backend (solo se la prop è attiva e lo switch è visibile)
                if (this.attachmentIncluded && response.data.info.hasOwnProperty('attachment_included_default')) {
                    this.model.attachmentIncluded = response.data.info.attachment_included_default
                }

                // Preselezionare il file più recente dalla categoria 'trouble' se richiesto
                if (response.data.info.preselect_recent_file) {
                    this.preselectMostRecentFile('trouble')
                }

                this.baseurl = response.data.info.baseurl
                this.fileUploaderInfo = response.data.info.file_uploader_info
                
                // Create safe default objects for when arrays are empty
                const defaultTemplate = { body: '', value: null }
                const defaultSignature = { body: '', value: null }
                
                // Follow the same pattern as SendMultipleMails.vue
                // Create a local variable for template selection
                const templateSelected = this.selectDefaultItem(
                    response.data.info.default_template_id, 
                    this.model['template_mail'], 
                    (this.model['template_mail'] && this.model['template_mail'].length > 0) ? 
                        this.model['template_mail'][0] : defaultTemplate
                )
                
                // Get default signature using the mixin method
                this.signatureSelected = this.selectDefaultItem(
                    response.data.info.signature_default_id, 
                    this.signatures, 
                    (this.signatures && this.signatures.length > 0) ? this.signatures[0] : defaultSignature
                )
                
                // Set the template_default_id and default_template in the model
                if (templateSelected && templateSelected.value) {
                    this.$set(this.model, 'default_template_id', templateSelected.value)
                }
                
                // Set the UI model property for the v-select
                this.model['default_template'] = templateSelected
                
                // Initially set a placeholder body
                this.model.body = ''
                
                // Parse the template variables if a default template is selected
                if (templateSelected && templateSelected.value) {
                    // Call the API to parse the template with variables
                    this.axios.post('parse-template', {
                        template_id: templateSelected.value, 
                        id: this.id, 
                        model_class: this.model_name
                    }).then(response => {
                        const parsedTemplate = { ...templateSelected, body: response.data.data.body }
                        
                        // Initialize email content with the parsed template
                        this.initializeEmailContent(parsedTemplate, this.signatureSelected)
                    })
                } else {
                    // If no template with variables to parse, initialize with what we have
                    this.initializeEmailContent(templateSelected, this.signatureSelected)
                }
                
                this.$store.commit('endProgress')
            }, response => {
                // error callback
            })
        }
    }
</script>
<style>
    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .file-card {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        transition: all 0.2s ease;
        background-color: #fafafa;
    }

    .file-card:hover {
        border-color: #1976d2;
        background-color: #f5f5f5;
    }

    .file-card--selected {
        border-color: #1976d2;
        background-color: #e3f2fd !important;
    }

    .file-info {
        min-width: 0;
        flex: 1;
        overflow: hidden;
    }

    .file-name {
        word-break: break-word;
        line-height: 1.3;
    }

    .theme--dark .file-card {
        background-color: #2d2d2d;
        border-color: #424242;
    }

    .theme--dark .file-card:hover {
        border-color: #64b5f6;
        background-color: #383838;
    }

    .theme--dark .file-card--selected {
        border-color: #64b5f6;
        background-color: #1e3a5f !important;
    }
</style>
